module.exports = {
  //API接口
  API_DOMAIN: 'api.marryandjoy.com:8443',
  API_DEBUG: false
};